__turbopack_context__.v({
  "questionnaireListItem": "QuestionnaireListItem-module__2NrrcW__questionnaireListItem",
});
